/* eslint-disable */
import store from "@/store";
import i18n from "@/i18n";
import {profilesMapping, PROFILES_ENUM} from "@/enums/profiles/profiles";

const ldapPwdMask = "Sistema Autenticação GSC";
import router from "@/router";
import { setInsuranceDropdown } from "@/utils/financialBkoForm/formMapperHandler";

export const carType = {
    "N": "Novo",
    "U": "Usado"
}

// Função para mapear serviço para dentro do formulário
function getValueFormData(data, fieldKey) {
    let value = data ? data[fieldKey] : "";
    if (fieldKey === "ID_PROFILE") value = profilesMapping[value];
    if (fieldKey === "STATUS" || fieldKey === "status") value = value === "S" || !value ? 1 : 2;
    if (fieldKey === "GENDER") value = value === "M" || !value ? 1 : 2;
    if (fieldKey === "PWD") value = value === "LDAP" ? ldapPwdMask : value;

    if (fieldKey === "api" || fieldKey === "ftp"
        || fieldKey === "emailAlertNewProposal"
        || fieldKey === "emailWithDocumentation" || fieldKey === "emailWithXML") {
        value = value == true ? 1 : 2;
    }

    //Tab - Frases legais
    if (fieldKey === "isPromoFinance") value = value === "S" ? 1 : 2;
    if (fieldKey === "carType") value = value !== "" ? carType[value] : "";

    return value;
}

function userDetailsMapperHandler(formObject, form, data, showPwd, toEdit = false) {
    form?.fields.map(async (field) => {

        if (field.key.startsWith('gnName') && data && data?.ID_PROFILE == PROFILES_ENUM.SELLER) {
            field.editable = true;
        }

        if ((field.type === "dropdown" || field.type === "multi-select") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    if (populateAction.type === "action") {
                        await store.dispatch(populateAction.name);
                    }

                    if (populateAction?.dependingOnProfile) {
                        const profilesList = store.getters[populateAction.name];
                        const idProfile = store.getters["AuthenticationModule/getIdProfile"];
                        // Quando o perfil é de Gestor negócio, apenas pode mostrar o tipo de perfil Vendedor (aquando da criação do utilizador)
                        field.options = (idProfile === PROFILES_ENUM.BUSINESS_MANAGER && !data) ? profilesList.filter(profile => profile.value === -1 || profile.value === PROFILES_ENUM.SELLER) : profilesList;

                        if (idProfile === PROFILES_ENUM.COORDINATOR) {
                            field.options?.map((option) => {
                                option.disabled = option?.value == -1 || option?.value == PROFILES_ENUM.ADMIN 
                                || option?.value == PROFILES_ENUM.COORDINATOR 
                                || option?.value == PROFILES_ENUM.SUPER_ADMIN;
                            });
                        }

                        if (idProfile === PROFILES_ENUM.ADMIN) {
                            field.options?.map((option) => {
                                option.disabled = option?.value == -1 || option?.value == PROFILES_ENUM.SUPER_ADMIN;//|| option?.value == 1
                            });
                        }
                    } else {
                        if(field.key === "entitiesList" && data) {
                            const entityOptions = store.getters[populateAction.name];
                            const idInstances = data?.instances?.map(instance => instance.ID);

                            field.options = entityOptions?.filter((item) => {
                                return idInstances.includes(item?.ID_INSTANCE);
                            });
                            const filteredEntityOptions = entityOptions?.filter((item) => {
                                return idInstances.includes(item?.ID_INSTANCE);
                            });
                        } else {
                            field.options = store.getters[populateAction.name];
                        }
                    }

                });
            }
        }

        // Se for um novo utilizador
        if (!data) {
            if (field.key === "LOGIN" || field.key === "PWD") field.editable = false;
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "createUser";
            formObject.btns[1].label = "Criar Utilizador";
            formObject.btns[1].icon = "circle-check";

            // Apenas mostrar a pesquisa para users novos
            if (field.key === "searchByNIF") {
                field.fieldShow = true;
            }
        } else {
            if (field.key === "PWD") field.inputType = !showPwd ? 'password' : 'text';
            
            if (field.key === "searchByNIF") {
                field.fieldShow = toEdit;
                field.required = false;
            }
        }


        if (field.type !== "text-label" && field.type !== 'multi-select') {
            field.value = getValueFormData(data, field.key);
        }

        // concatena o prefixo dos contactos consoante o form nationality
        if (field.key.startsWith("PHONE")) {
            field.value = getValueFormData(data, field.key);
            //const country = "PT";
            const currentNationality = getValueFormData(data, "NATIONALITY");

            if (currentNationality) {
                field.prefixValue = currentNationality === 'PT' ? "+351" : "+34";
            } else {
                field.prefixValue = i18n.locale === 'pt' ? "+351" : "+34";
            }

        }

        if (field.key.startsWith("entitiesList") || field.key.startsWith("instances")) {
            field.value = getValueFormData(data, field.key) ? getValueFormData(data, field.key) : [];
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;
        field.keyReRender = 1;
    });

    return form;
}

const lockFieldsByProfile = (formObject, toEdit, data) => {

    const idProfile = store.getters["AuthenticationModule/getIdProfile"];
    const userID = store.getters["AuthenticationModule/getUserId"];
    const ID = data?.ID;
    const isChildren = data?.isChildren;

    // Apenas ver - não é possível editar
    if (!toEdit) {
        formObject?.form?.map((form) => form?.fields?.map((formFields) => formFields.editable = false));
        formObject.btns[1] = {};
    } else {
        formObject?.form?.map((form) => form?.fields?.map((formFields) => {if(formFields.key !== 'PWD') formFields.editable = true}));
        
        switch (idProfile) {
            // case PROFILES_ENUM.SUPER_ADMIN:
            // case PROFILES_ENUM.ADMIN:
            // case PROFILES_ENUM.BUSINESS_BOSS:
            // case PROFILES_ENUM.BUSINESS_MANAGER:
            case PROFILES_ENUM.COORDINATOR:
                const editableFieldsCoordinator = ["NIF", "PHONE", "EMAIL", "NATIONALITY", "ID_PROFILE", "entitiesList"];
                formObject?.form?.map((form) => form?.fields?.map((formFields) => formFields.editable = editableFieldsCoordinator.includes(formFields?.key)));
            // case PROFILES_ENUM.FINANCIAL:
            // case PROFILES_ENUM.FINANCIAL_JR:
            // case PROFILES_ENUM.MANAGER:
            case PROFILES_ENUM.BUSINESS_MANAGER:
            case PROFILES_ENUM.SELLER:
                // Compara o id do user atual com o id do user pesquisado
                // Se for igual apenas deixar o phone editable
                if (String(userID) === String(ID)) {
                    const editableFieldsSeller = ["PHONE"];
                    formObject?.form?.map((form) => form?.fields?.map((formFields) => formFields.editable = editableFieldsSeller.includes(formFields?.key)));
                } else if (isChildren) {
                    const editableFieldsSeller = ["PHONE", "entitiesList", "STATUS"];
                    formObject?.form?.map((form) => form?.fields?.map((formFields) => formFields.editable = editableFieldsSeller.includes(formFields?.key)));
                }
        }
    }

    return formObject;
};

const lockFields = (formObject, toEdit, data) => {

    // Apenas ver - não é possível editar
    if (!toEdit) {
        formObject?.form?.map((form) => form?.fields?.map((formFields) => formFields.editable = false));
        formObject.btns[1] = {};
    }

    return formObject;
};

function userDetailsFormMapper(data, formKey, showPwd, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => userDetailsMapperHandler(formObject, form, data, showPwd, toEdit));
        formObject = lockFieldsByProfile(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const userDetailsFormUnmapper = ({saveObject, formData}) => {
    const unmappedFormObj = saveObject;
    formData?.form?.map((section) => section?.fields?.map((field) => {
        if (field?.key === 'ID_PROFILE') {
            const findOptionValue = field?.options?.find((option) => option.text === field.value);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if (field?.key === 'gnName') {
            const findOptionValue = field?.options?.find((option) => option.text === field.value);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if (field?.key === 'GENDER') {
            unmappedFormObj[field.saveKey] = field?.value === 1 ? "M" : "F";
        } else if (field?.key === 'STATUS') {
            unmappedFormObj[field.saveKey] = field?.value === 1 ? "S" : "N";
        } else if (field?.key === 'PWD') {
            unmappedFormObj[field.saveKey] = field?.value === ldapPwdMask ? "LDAP" : field?.value;
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    return unmappedFormObj;
};

function entityDetailsFormMapper(data, formKey, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => entityDetailsMapperHandler(formObject, form, data, toEdit));
        formObject = lockFields(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

function entityDetailsMapperHandler(formObject, form, data, toEdit) {
    const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;

    form?.fields.map(async (field) => {

        if (field.key.startsWith('ID_BUSINESSMANAGER_PRINCIPAL') && data) {
            field.fieldShow = true;
        }

        if (field.key.startsWith('ID_GSC_INSTALLATION') && !(idInstance == 1 || idInstance == 2)) {
            field.fieldShow = false;
        }

        if (field.key.startsWith('EXTERNAL_ENTITY_CODE') && data && data?.COUNTRY === 'PT') {
            field.fieldShow = true;
        }

        if (field.key.startsWith('CP3') && data) {
            field.fieldShow = true;
            let districtField = form.fields.find((f) => f?.key?.startsWith("DISTRICT"));
            districtField.colspan = 3;
            if (data?.COUNTRY === 'ES') {
                field.fieldShow = false;
                districtField.colspan = 5;
            }
        }

        if ((field.type === "dropdown") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    if (populateAction.type === "action" && !(field.key.startsWith('CPEXT') || field.key.startsWith('OID_DEALER'))) {
                        await store.dispatch(populateAction.name);
                    }

                    if (populateAction.payload === "postalCode") {
                        const country = data?.COUNTRY === 'ES' ? "ES" : "PT";
                        await postalCodeHandler(form, data, country, populateAction);
                    }

                    if (field.key.startsWith('ID_GROUP') || field.key.startsWith('ID_ENTITYCOMPANY')
                        || field.key.startsWith('ID_GSC_INSTALLATION') || field.key.startsWith('ID_BUSINESSMANAGER_PRINCIPAL') 
                        || field.key.startsWith('COUNTRY') || field.key.startsWith('OID_DEALER')
                        || field.key.startsWith('ID_INSTANCE')
                    ) {
                        const value = getValueFormData(data, field.key);

                        field.options = store.getters[populateAction.name];
                        field.options?.map((option) => {
                            option.selected = option?.value == value;
                        });

                        if (field.key.startsWith('COUNTRY')) {
                            field.value = value;
                            
                            store.commit("EntityBkoFormModule/setFieldAttribute", {
                                key: field?.key,
                                attribute: 'options',
                                value: field.options
                            });
                            store.commit("EntityBkoFormModule/setFieldValue", field);
                            store.commit("EntityBkoFormModule/setIncrementField", {key: field?.key});
                        }
                        if (field.key.startsWith('ID_INSTANCE')) {
                            const valueInstance = value || idInstance;

                            const optionSelected = field.options?.find((option) => option?.value == valueInstance);

                            store.commit("EntityBkoFormModule/setFieldAttribute", {
                                key: field?.key,
                                attribute: 'options',
                                value: field.options
                            });

                            field.value = (field?.valueText ? optionSelected?.text : optionSelected?.value) || value;
                            field.valueOptionSelected = optionSelected?.value || value;
                            //field.selectedValue = value || '-1';
                            //store.commit("EntityBkoFormModule/setFieldValue", field);
                            //store.commit("EntityBkoFormModule/setIncrementField", {key: field?.key});
                        }
                    } else {
                        if (!field.key.startsWith('CPEXT')) {
                            field.options = store.getters[populateAction.name];
                            const value = getValueFormData(data, field.key);

                            field.options?.map((option) => {
                                option.selected = option?.value == value;
                            });
                        }
                    }

                    if (!field.key.startsWith('ID_INSTANCE')) {
                        field.keyReRender++;
                    }
                });
            }


        }

        // Se for um novo entidade /Pontos de Venda
        if (!data) {
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "createEntity";
            formObject.btns[1].label = "Criar Ponto de Venda";
            formObject.btns[1].icon = "circle-check";
        }

        if (field.type !== "text-label" && field.type !== 'multi-select' && field.type !== "dropdown" && field.type !== "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;

        if (field.type !== "neo-toggle") {
            field.keyReRender = 1;
        }
    });

    return form;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const entityDetailsFormUnmapper = ({saveObject, formData}) => {
    let unmappedFormObj = saveObject;
    const countryField = formData?.form?.find((section) => section?.key.startsWith('generalData')).fields?.find((field) => field?.key?.startsWith('COUNTRY'));
    const isSpain = countryField?.value === 'ES';

    formData?.form?.map((section) => section?.fields?.map((field) => {
        if (field?.type === 'dropdown') {
            const findOptionValue = field?.options?.find((option) => option.selected);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if (field?.key === 'STATUS') {
            unmappedFormObj[field.saveKey] = field?.value === 1 ? "S" : "N";
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    if (isSpain) delete unmappedFormObj['CP3'];

    return unmappedFormObj;
};

async function postalCodeHandler(form, data, country, populateAction) {
    let cpExtField = form.fields.find((field) => (field?.key?.startsWith('CPEXT')));
    const districtField = form.fields.find((f) => (f?.key?.startsWith("DISTRICT")));
    const cp4Field = form.fields.find((f) => f?.key?.startsWith("CP4"));
    const cp4Value = cp4Field?.value?.toString();

    // Para Portugal
    if (country === "PT") {
        const cp3Field = form.fields.find((f) => f?.key?.startsWith("CP3"));
        const cp3Value = cp3Field?.value?.toString();

        if (cp4Value.length === 4 && cp3Field?.maxLength === cp3Value.length) {
            const postalCodeValue = cp4Value + cp3Value;
            const {districtValue} = await store.dispatch(populateAction.name, {
                formNationality: country,
                localityFieldKey: cpExtField?.key,
                postalCode: postalCodeValue
            });
            //Distrito
            districtField.value = districtValue;
            districtField.editable = false;
            //Cidade
            const cityValues = store.getters["EntityBkoFormModule/getSearchByPostalCode"](cpExtField.key);

            if (cityValues.length > 1) {
                if (cityValues.length >= 2) {
                    cityValues?.map((option) => {
                        option.selected = option?.value == data?.CPEXT;
                    });

                    // Create a promise to handle the asynchronous update
                    const updateAddress1CityValue = new Promise((resolve) => {
                        resolve(cityValues[1]?.text);
                    });

                    // Update cpExtField.value when the promise is resolved
                    updateAddress1CityValue.then((updatedValue) => {
                        cpExtField.value = updatedValue;
                        console.log(cityValues[1]?.text, cpExtField.value);
                    });
                }
                store.commit("EntityBkoFormModule/setFieldAttribute", {
                    key: cpExtField?.key,
                    attribute: 'options',
                    value: cityValues
                });
                store.commit("EntityBkoFormModule/setFieldValue", cpExtField);
                store.commit("EntityBkoFormModule/setIncrementField", {key: cpExtField?.key});
            } else {
                cpExtField.type = "text";
            }

        } else {
            cpExtField.type = "text";
        }
    }
    // Para Espanha
    else {
        if (cp4Value?.length >= 4 && cp4Value?.length <= 5) {
            const {districtValue} = await store.dispatch(populateAction.name, {
                formNationality: country,
                localityFieldKey: cpExtField?.key,
                postalCode: cp4Value
            });
            //Distrito
            districtField.value = districtValue;
            districtField.editable = false;
            //Cidade
            const cityValues = store.getters["EntityBkoFormModule/getSearchByPostalCode"](cpExtField.key);
            if (cityValues.length > 1) {
                if (cityValues.length === 2) {
                    cityValues[1].selected = true;

                    // Create a promise to handle the asynchronous update
                    const updateAddress1CityValue = new Promise((resolve) => {
                        resolve(cityValues[1]?.text);
                    });

                    // Update cpExtField.value when the promise is resolved
                    updateAddress1CityValue.then((updatedValue) => {
                        cpExtField.value = updatedValue;
                        console.log(cityValues[1]?.text, cpExtField.value);
                    });
                }
                store.commit("EntityBkoFormModule/setFieldAttribute", {
                    key: cpExtField?.key,
                    attribute: 'options',
                    value: cityValues
                });
                store.commit("EntityBkoFormModule/setFieldValue", cpExtField);
                store.commit("EntityBkoFormModule/setIncrementField", {key: cpExtField?.key});
            } else {
                cpExtField.type = "text";
            }
        } else {
            cpExtField.type = "text";
        }
    }
}

function companyDetailsFormMapper(data, formKey, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => companyDetailsMapperHandler(formObject, form, data, toEdit));
        formObject = lockFields(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

function companyDetailsMapperHandler(formObject, form, data, toEdit) {
    form?.fields.map(async (field) => {

        if ((field.type === "dropdown" || field.type === "multi-select") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    if (populateAction.type === "action") {
                        await store.dispatch(populateAction.name);
                    }

                    const value = getValueFormData(data, field.key);

                    field.options = store.getters[populateAction.name];
                    field.options?.map((option) => {
                        option.selected = option?.value === value;
                    });

                    if (field.key?.startsWith("country")) {
                        field.value = value;
                        store.commit("CompanyBkoFormModule/setFieldAttribute", {
                            key: field?.key,
                            attribute: 'options',
                            value: field.options
                        });
                        store.commit("CompanyBkoFormModule/setFieldValue", {"key": field?.key, "value": value});
                        store.commit("CompanyBkoFormModule/setIncrementField", {key: field?.key});
                    }

                    field.keyReRender++;
                });
            }
        }

        // Se for uma nova empresa
        if (!data) {
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "createCompany";
            formObject.btns[1].label = "Criar Empresa";
            formObject.btns[1].icon = "circle-check";
        }

        if(data) {
            formObject.form[1].fieldShow = true;
        }

        if (field.type !== "text-label" && field.type !== 'multi-select' && field.type !== "dropdown" && field.type !== "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if ((field.key === "downloadCompanyDoc" || field.key === "deleteCompanyDoc") && data) {
            field.fieldShow = false;
        }

        if (field.key === "contractSheet" && data) {
            field.fieldShow = toEdit || false;
        }

        if (field.key === "documents" && data) {
            field.fieldShow = true;
        }

        if (field.key.startsWith("entityGroups")) {
            field.value = getValueFormData(data, field.key) ? getValueFormData(data, field.key) : [];
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;

        if (field.type !== "neo-toggle") {
            field.keyReRender = 1;
        }
    });

    return form;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const companyDetailsFormUnmapper = ({saveObject, formData}) => {
    let unmappedFormObj = saveObject;

    formData?.form?.map((section) => section?.fields?.map((field) => {
        if (field?.type === 'dropdown') {
            const findOptionValue = field?.options?.find((option) => option.selected);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if (field?.key === 'status') {
            unmappedFormObj[field.saveKey] = field?.value === 1 ? "S" : "N";
        } else if (field?.type === 'number') {
            unmappedFormObj[field.saveKey] = field.value === "" ? -1 : field.value;
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    return unmappedFormObj;
};

function financialRateSiteDetailsFormMapper(data, formKey, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => financialRateSiteDetailsMapperHandler(formObject, form, data, toEdit));
        formObject = lockFields(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

function financialRateSiteDetailsMapperHandler(formObject, form, data, toEdit) {
    form?.fields.map(async (field) => {

        if ((field.type === "dropdown") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    if (populateAction.type === "action") {
                        await store.dispatch(populateAction.name);
                    }

                    const value = getValueFormData(data, field.key);

                    field.options = store.getters[populateAction.name];
                    field.options?.map((option) => {
                        option.selected = option?.value === value;
                    });

                    if (field.key?.startsWith("country")) {
                        field.value = value;
                        store.commit("FinancialRateOfSiteBkoFormModule/setFieldAttribute", {
                            key: field?.key,
                            attribute: 'options',
                            value: field.options
                        });
                        store.commit("FinancialRateOfSiteBkoFormModule/setFieldValue", {
                            "key": field?.key,
                            "value": value
                        });
                        store.commit("FinancialRateOfSiteBkoFormModule/setIncrementField", {key: field?.key});
                    }

                    field.keyReRender++;
                });
            }
        }

        if (field.type !== "text-label" && field.type !== 'multi-select' && field.type !== "dropdown" && field.type !== "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;

        if (field.type !== "neo-toggle") {
            field.keyReRender = 1;
        }
    });

    return form;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const financialRateSiteDetailsFormUnmapper = ({saveObject, formData}) => {
    let unmappedFormObj = saveObject;

    formData?.form?.map((section) => section?.fields?.map((field) => {
        if (field?.type === 'dropdown') {
            const findOptionValue = field?.options?.find((option) => option.selected);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if (field?.type === 'number') {
            unmappedFormObj[field.saveKey] = field.value === "" ? -1 : field.value;
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    return unmappedFormObj;
};

function spreadsFormMapper(data, formKey, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => spreadsMapperHandler(formObject, form, data, toEdit, formKey));
        formObject = lockFields(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

function spreadsMapperHandler(formObject, form, data, toEdit, formKey) {
    form?.fields.map(async (field) => {

        if ((field.type === "dropdown" || field.type === "multi-select") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    const routeParams = router.currentRoute.params;
                    const financeId = routeParams.id;
                    const idInstance = routeParams.idInstance;

                    if (populateAction.type === "action") {
                        await store.dispatch(populateAction.name);
                    }

                    if(field.key.startsWith('insurancesList')) {
                        field.options = [];
                        field.options = await setInsuranceDropdown(populateAction, { idFinancial: financeId, idInstance: idInstance });
                        //field.keyReRender++;
                    }

                    if (field.key.startsWith('idEntityCompany') || field.key.startsWith('idClientType')
                        || field.key.startsWith('brand') || field.key.startsWith('idProduct') || field.key.startsWith('periodicity')
                        || field.key.startsWith('vehicleStatus')
                    ) {
                        const financeId = routeParams.id;
                        
                        const value = getValueFormData(data, field.key);
                        
                        field.options = store.getters[populateAction.name];

                        field.options?.map((option) => {
                            option.selected = option?.value === value;
                        });
                    }

                    field.keyReRender++;
                });
            }

        }

        // Se for um novo spread
        if (!data && formKey == 'spreadDetails') {
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "createSpreads";
            formObject.btns[1].label = "Criar Spreads";
            formObject.btns[1].icon = "circle-check";
        }

        if (!data && formKey == 'financialTinDetails') {
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "addTinToFinancial";
            formObject.btns[1].label = "Guardar";
            formObject.btns[1].icon = "circle-check";
        }

        if (field.type !== "text-label" && field.type !== 'multi-select' && field.type !== "dropdown" && field.type !== "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;

        if (field.type !== "neo-toggle") {
            field.keyReRender = 1;
        }
    });

    return form;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const spreadsFormUnmapper = ({saveObject, formData}) => {
    let unmappedFormObj = saveObject;

    formData?.form?.map((section) => section?.fields?.map((field) => {
        if (field?.type === 'dropdown') {
            const findOptionValue = field?.options?.find((option) => option.selected);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    return unmappedFormObj;
};

//Frases legais
function disclaimerFormMapper(data, formKey, toEdit) {
    //Limpar a cache - uso do require mantem a cache
    delete require.cache[require.resolve(`../forms/${formKey}.json`)];
    let formObject = require(`../forms/${formKey}.json`);

    try {
        formObject?.form?.map(async (form) => disclaimerMapperHandler(formObject, form, data, toEdit, formKey));
        formObject = lockFields(formObject, toEdit, data);
    } catch (e) {
        console.log(e);
    }

    return formObject;
}

function disclaimerMapperHandler(formObject, form, data, toEdit, formKey) {
    toEdit;

    form?.fields.map(async (field) => {

        if ((field.type === "dropdown" || field.type === "multi-select") && field.populateOptionsActions) {
            if (field.populateOptionsActions) {
                field.populateOptionsActions.map(async (populateAction) => {
                    if (populateAction.type === "action") {
                        await store.dispatch(populateAction.name);
                    }

                    const value = getValueFormData(data, field.key);

                    field.options = await store.getters[populateAction.name];
                    field.options?.map((option) => {
                        option.selected = option?.value === value;
                    });

                    if (field.key.startsWith('carType') || field.key.startsWith('wsOrigin')) {
                        field.value = value || '';
                    }

                    if (field.key?.startsWith("idProduct")) {
                        field.selectedValue = value || '-1';
                    } 

                    field.keyReRender++;
                });
            }

        }

        // Se for um novo disclaimer
        if (!data) {
            // Alterar o botão de Guardar para ---> Criar
            formObject.btns[1].key = "newDisclaimer";
            formObject.btns[1].label = "Guardar";
            formObject.btns[1].icon = "circle-check";
        }
        if (field.type !== "text-label" && field.type !== 'multi-select' && 
            field.type !== "dropdown" && field.type !== "neo-toggle" && field.type !== "editor"
        ) {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "editor" || field.type === "vue2-editor") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        if (field.type === "neo-toggle") {
            field.value = getValueFormData(data, field.key);
            field.keyReRender++;
        }

        //set default properties
        field.hasError = field.hasError || false;
        field.editable = field.editable || false;
        field.required = field.required || false;
        field.loading = field.loading || false;

        if (field.type !== "neo-toggle") {
            field.keyReRender = 1;
        }
    });

    return form;
}

/** recebe o objeto do formulário guardado e preenche de acordo com o formData saveKeys */
const disclaimerFormUnmapper = ({saveObject, formData}) => {
    let unmappedFormObj = saveObject;

    formData?.form?.map((section) => section?.fields?.map((field) => {
        
        if (field?.type === 'dropdown') {
            const findOptionValue = field?.options?.find((option) => option.selected);
            unmappedFormObj[field.saveKey] = findOptionValue?.value;
        } else if(field?.key === "isPromoFinance") {
            unmappedFormObj[field.saveKey] = field.value == 1 ? "S" : "N";
        } else {
            unmappedFormObj[field.saveKey] = field.value;
        }
    }));

    return unmappedFormObj;
};

export {
    userDetailsFormMapper,
    userDetailsFormUnmapper,
    userDetailsMapperHandler,
    entityDetailsFormMapper,
    entityDetailsFormUnmapper,
    entityDetailsMapperHandler,
    companyDetailsFormMapper,
    companyDetailsMapperHandler,
    companyDetailsFormUnmapper,
    financialRateSiteDetailsFormMapper,
    financialRateSiteDetailsFormUnmapper,
    spreadsFormMapper,
    spreadsFormUnmapper,
    disclaimerFormMapper,
    disclaimerFormUnmapper,
};


